<div  class="page-layout blank fullwidth" (scroll)="onScroll()" fusePerfectScrollbar style="height: 1px; overflow-y: scroll; margin-bottom: 5em;    top: 1px;    background: linear-gradient(45deg, #e2e8f8, #F8FAFF);" >
  <div class="page-wrapper" *ngIf="!showEmptyState">

    <!-- ===== HERO: 2-col grid (image left, info right) ===== -->
    <div class="product-hero">

      <!-- Left: Image Gallery -->
      <div class="product-gallery">
        <div class="main-image-wrapper">

          <span class="badge-discount" *ngIf="selectedItem?.discount">
            {{ selectedItem?.discount }}% off
          </span>

          <span class="badge-sold">
            {{ selectedItem?.raw?.partInfo?.soldCount || 0 }} Units Sold
          </span>
          <span class="badge-stock">
            ⏳ Limited stock at JC Road
          </span>
          <img
            [src]="selectedImage || defaultImage"
            [alt]="selectedItem?.partName"
            class="main-image"
            (error)="onImageError($event)"
          />

        </div>
        <!-- Thumbnail Strip -->
        <div class="thumbnail-strip" *ngIf="clutchList?.length > 1">
          <div 
            class="thumbnail-item"
            *ngFor="let item of clutchList"
            [ngClass]="{ active: item.image === selectedImage }"
            (click)="selectImage(item)"
          >
            <img [src]="item.image" />
          </div>
        </div>
      </div>
      <!-- Right: Product Info 1st ui -->
       <div *ngIf="isFullKit">
        <div class="product-info">
          <h1 class="product-title">
            {{ pricingSummary?.title || 'Clutch Product' }}
          </h1>

          <div class="rating-row">
            <span class="star">&#9733;</span>
            <span class="star">&#9733;</span>
            <span class="star">&#9733;</span>
            <span class="star">&#9733;</span>
            <span class="star">&#9733;</span>
            <span class="rating-count">5 Ratings</span>
          </div>

          <div class="delivery-row">
            <svg class="truck-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
            </svg>
            <span class="delivery-text"> Dispatched in 15 Mins</span>
          </div>

          <div class="price-box">
            <div class="price-row">
                <span class="current-price">
                    ₹{{ pricingSummary?.totalSellingPrice || 0 }}
                </span>

                <span class="original-price" *ngIf="selectedItem?.mrp">
                    ₹{{ pricingSummary?.totalMrp }}
                </span>

                <div style="display: flex;    align-items: center;" *ngIf="selectedItem?.saveAmount">
                  <img src="../../../../assets/images/productdetailsimage/save.png" style="margin: 10px;">
                  <span class="save-badge" >
                      Save ₹{{ pricingSummary?.savings }}
                  </span>
              </div>

            </div>
            <p class="tax-note">Inclusive of all taxes</p>
          </div>
          <!-- TAGS ROW -->
          <div class="clutch-set-bran-main" >

            <div class="clutch-set-brand">
              <span>🏷️ Brand: </span><span class="clutch-set-brand-sub">{{ clutchList[0]?.brand }}</span>
            </div>

            <div class="clutch-set-brand">
              <span>🔩 Part: </span><span class="clutch-set-brand-sub" >{{ clutchList[0]?.partNumber }}</span>
            </div>

            <div class="clutch-set-brand">
              <span>🟢 Type:</span>
              <span class="clutch-set-brand-sub" >{{ clutchList[0]?.partType }}</span> 
            </div>

          </div>

          <!-- AVAILABILITY + DELIVERY -->
          <!-- <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:10px;">

            <div style="color:green; font-weight:600;">
              ✅ Available
            </div>

            <div style="background:#fff3e0; padding:6px 10px; border-radius:8px; font-size:12px;">
              ⚡ Dispatches in 15 mins
            </div>

          </div> -->
          <!-- WHAT YOU GET -->
          <p  class="wht-u-get">
            WHAT YOU GET IN THIS KIT
          </p>
          <!-- ITEMS LIST -->
          <div *ngFor="let item of clutchList"  class="parts-inld">
            <div class="prt-nms">
              <span *ngIf="item.partName?.toLowerCase().includes('disc')" >💿</span>
                <span *ngIf="item.partName?.toLowerCase().includes('cover') || item.partName?.toLowerCase().includes('plate')">🔧</span>
                <span *ngIf="item.partName?.toLowerCase().includes('bearing')">⚙️</span>
                <div *ngIf="item.partName?.toLowerCase().includes('flywheel') || item.partName?.toLowerCase().includes('fly wheel')">
                  <img src="../../../../assets/images/clutch-flyingwheel.png" class="part-icon">
                </div>
              {{ item.partName }}
            </div>
            <div class="inld">
              Included
            </div>
          </div>
          <!-- <div style="background:#e8f5e9; padding:10px; border-radius:8px; text-align:center; font-weight:600; margin:10px 0;">
            ✅ All {{ clutchList.length }} parts included in this kit
          </div> -->
          <div class="sticky-cta"   >
            <button class="btn-add-cart" (click)="onAddToCart()" #stickyBtn>
              ⚡ Order Complete Kit
            </button>
            <div class="evrythng">Everything included. No extra parts needed.</div>
          </div>

        </div>
      </div>
      <!-- END .product-info -->
      <!-- Right: Product Info 2nd ui -->
       <div class="right-container" *ngIf="!isFullKit">
        <div class="scrollable-content" #productSection>
          <div class="product-info">
            <h1 class="product-title">
              {{ pricingSummary?.title || 'Clutch Product'}}
            </h1>

            <div class="rating-row">
              <span class="star">&#9733;</span>
              <span class="star">&#9733;</span>
              <span class="star">&#9733;</span>
              <span class="star">&#9733;</span>
              <span class="star">&#9733;</span>
              <span class="rating-count">5 Ratings</span>
            </div>

            <div class="delivery-row">
              <svg class="truck-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
              </svg>
              <span class="delivery-text"> Dispatched in 15 Mins</span>
            </div>

            <div class="price-box">
              <div class="price-row">
                  <span class="current-price">
                      ₹{{ pricingSummary?.totalSellingPrice || 0 }}
                  </span>

                  <span class="original-price" *ngIf="selectedItem?.mrp">
                      ₹{{ pricingSummary?.totalMrp  }}
                  </span>

                  <div style="display: flex;    align-items: center;" *ngIf="selectedItem?.saveAmount">
                    <img src="../../../../assets/images/productdetailsimage/save.png" style="margin: 10px;">
                    <span class="save-badge" >
                        Save ₹{{ pricingSummary?.savings }}
                    </span>
                </div>

              </div>
              <p class="tax-note">Inclusive of all taxes</p>
            </div>
            
            <!-- WHAT YOU GET -->
            <p  class="wht-u-get">
              WHAT YOU GET IN THIS KIT
            </p>
            <div class="split-row-parent">
                <div class="split-row">
                <div class="row-top">
                    <div class="left">
                    <div class="icons">
                        <div class="icon bg-yellow">💿</div>
                        <div class="icon bg-blue">⚙️</div>
                    </div>
                    <div class="info">
                        <div class="top-line">
                          <h4>Clutch Set</h4>

                          <span class="type-tag">
                            {{ clutchList[0]?.partType }}
                          </span>
                        </div>
                          <span class="sub-include">Includes {{ clutchList[0]?.partName || 'Includes parts' }}</span>
                          <span class="sub">🏭<span class="label">Brand:</span>  <span class="value">{{ clutchList[0]?.brand || '-' }}</span></span>
                          <span class="sub">🔢 <span class="label">Part Number:</span> <span class="value">{{ clutchList[0]?.partNumber || clutchList[0]?.partNo || '-' }}</span></span>
                            <!-- EXISTING -->
                        <div class="right">
                            <span class="price-val">₹{{ clutchList[0]?.sellingPrice || 0 }}<span class="mrp">₹{{ clutchList[0]?.mrp || 0 }}</span></span>
                            <span class="price-tag">Clutch Set price</span>
                        </div>
                        <div class="badge">✔ Pre-assembled set</div>
                    </div>
                    </div>
                </div>
                <!-- badge sits inside the box, below the row -->
                
                </div>

                <!-- BEARING ROW -->
                <div class="split-row" *ngIf="clutchList.length > 1">
                <div class="row-top" style="display: flex; justify-content: space-between; align-items: flex-start; gap: 10px;">
                    <div class="left"  style="display: flex; gap: 10px; flex: 1; min-width: 0;">
                    <div class="icon bg-gray">🔩</div>
                    <div style="width: 100%; gap: 10px;">
                        <div class="info" style="flex: 1; min-width: 0;">
                            <!-- <h4>  {{ clutchList[1]?.partName || 'Part 2' }}</h4>
                            <span class="sub">  {{ clutchList[1]?.partName || '' }}</span> -->
                            <div class="top-line" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <h4>{{ clutchList[1]?.partName || 'Part 2' }}</h4>

                            <span class="type-tag">
                              {{ clutchList[1]?.partType }}
                            </span>
                          </div>
                          <!-- <span class="sub">🏭 Brand: {{ clutchList[1]?.brand || '-' }}</span>
                          <span class="sub">
                            🔢 Part Number: 
                            {{ clutchList[1]?.partNumber || clutchList[1]?.partNo || '-' }}
                          </span> -->
                          <!-- <span class="sub-include">Includes {{ clutchList[1]?.partName || 'Includes parts' }}</span> -->
                          <span class="sub">🏭<span class="label">Brand:</span>  <span class="value">{{ clutchList[1]?.brand || '-' }}</span></span>
                          <span class="sub">🔢 <span class="label">Part Number:</span> <span class="value">{{ clutchList[1]?.partNumber || clutchList[1]?.partNo || '-' }}</span></span>
                        </div>
                        <div class="right">
                            <span class="price-val">₹{{ clutchList[1]?.sellingPrice || 0 }}<span class="mrp">₹{{ clutchList[1]?.mrp || 0 }}</span></span>
                            <span class="price-tag"> {{ clutchList[1]?.partName || 'Part' }} price</span>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <!-- <div class="price-breakdown">
            <div style="display: flex; justify-content: space-between;">
              <p class="pb-label">Total Kit Price</p>
              <h3 style="font-weight: 900;">₹{{ totalPrice | number:'1.2-2' }}</h3>
            </div>
            <div class="pb-divider"></div>
            <div class="pb-total">
                <span>Better value when ordered together</span>
            </div>
          </div> -->
          </div>
          <div class="sticky-cta"   >
            <button class="btn-add-cart" (click)="onAddToCart()" #stickyBtn>
              ⚡ Order Complete Kit
            </button>
            <div class="evrythng">Everything included. No extra parts needed.</div>
          </div>
        </div>
        </div>
        <button 
          class="floating-cta" 
          *ngIf="showFloatingBtn"
          (click)="onAddToCart()">
          ⚡ Order Complete Kit
        </button>
       <!-- END .product-info -->
    </div>
    <!-- END .product-hero -->
    <!-- ===== CLUTCH KIT UI SWITCH ===== -->
      <div class="kit-wrapper">

      <!-- ══════════════════════════════════════════
          SPLIT UI — 2 variables (!isFullKit)
      ══════════════════════════════════════════ -->
      <div *ngIf="!isFullKit" class="kit-card split">

          <!-- <div class="kit-header">
          <h2>Clutch Kit – Complete Set</h2>
          <p>All parts included. No need to buy anything else.</p>
          </div>
          <p class="section-title">WHAT YOU GET</p>
          <div class="split-row-parent">
              <div class="split-row">
              <div class="row-top">
                  <div class="left">
                  <div class="icons">
                      <div class="icon bg-yellow">💿</div>
                      <div class="icon bg-blue">⚙️</div>
                  </div>
                  <div class="info">
                      <div class="top-line">
                        <h4>Clutch Set</h4>
                        <span class="type-tag">
                          {{ clutchList[0]?.partType }}
                        </span>
                      </div>
                        <span class="sub-include">Includes {{ clutchList[0]?.partName || 'Includes parts' }}</span>
                        <span class="sub">🏭<span class="label">Brand:</span>  <span class="value">{{ clutchList[0]?.brand || '-' }}</span></span>
                        <span class="sub">🔢 <span class="label">Part Number:</span> <span class="value">{{ clutchList[0]?.partNumber || clutchList[0]?.partNo || '-' }}</span></span>
                      <div class="right">
                          <span class="price-val">₹{{ clutchList[0]?.sellingPrice || 0 }}<span class="mrp">₹{{ clutchList[0]?.mrp || 0 }}</span></span>
                          <span class="price-tag">Clutch Set price</span>
                      </div>
                      <div class="badge">✔ Pre-assembled set</div>
                  </div>
                  </div>
              </div>
              </div>
              <div class="split-row" *ngIf="clutchList.length > 1">
              <div class="row-top" style="display: flex; justify-content: space-between; align-items: flex-start; gap: 10px;">
                  <div class="left"  style="display: flex; gap: 10px; flex: 1; min-width: 0;">
                  <div class="icon bg-gray">🔩</div>
                  <div style="width: 100%; gap: 10px;">
                      <div class="info" style="flex: 1; min-width: 0;">
                          <div class="top-line" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                          <h4>{{ clutchList[1]?.partName || 'Part 2' }}</h4>

                          <span class="type-tag">
                            {{ clutchList[1]?.partType }}
                          </span>
                        </div>
                        <span class="sub">🏭<span class="label">Brand:</span>  <span class="value">{{ clutchList[1]?.brand || '-' }}</span></span>
                        <span class="sub">🔢 <span class="label">Part Number:</span> <span class="value">{{ clutchList[1]?.partNumber || clutchList[1]?.partNo || '-' }}</span></span>
                      </div>
                      <div class="right">
                          <span class="price-val">₹{{ clutchList[1]?.sellingPrice || 0 }}<span class="mrp">₹{{ clutchList[1]?.mrp || 0 }}</span></span>
                          <span class="price-tag"> {{ clutchList[1]?.partName || 'Part' }} price</span>
                      </div>
                  </div>
                  </div>
              </div>
              </div>
          </div> -->
          <div class="included-bar"> ✅ Complete kit ( {{ selectedItem?.partName }} <span *ngIf="clutchList.length > 1">   + {{ clutchList[1]?.partName }} </span> included)</div>

          <!-- PRICE BREAKDOWN BOX -->
          <div class="price-breakdown">
          <p class="pb-label">PRICE BREAKDOWN</p>
          <div class="pb-divider"></div>
          <div class="pb-row" *ngFor="let item of clutchList">
              <span class="pb-name">{{ item?.partName }}</span>
              <span class="pb-val">₹{{ item?.sellingPrice || 0 }}<span class="mrp">₹{{ clutchList[1]?.mrp || 0 }}</span></span>
          </div>
          <div class="pb-divider"></div>
          <div class="pb-total">
            <h3>
              ₹{{ pricingSummary?.totalSellingPrice || 0 }}
              <span class="mrp" *ngIf="pricingSummary?.totalMrp">
                ₹{{ pricingSummary?.totalMrp }}
              </span>
              <div style="display: flex;    align-items: center;" *ngIf="selectedItem?.saveAmount">
                  <img src="../../../../assets/images/productdetailsimage/save.png" style="margin: 10px;">
                  <span class="save-badge" style=" color: #D4AF37; " >
                      Save ₹{{ pricingSummary?.savings }}
                  </span>
              </div>
            </h3>
            <span>Final price • Full kit</span>
          </div>
          </div>

          <!-- DELIVERY — row -->
          <p class="section-title top-gap">DELIVERY TIMELINE</p>
          <div class="delivery-row">
          <div class="delivery-card blue">
              <div class="d-icon">⏱️</div>
              <p>Ready in 15 mins</p>
              <span>Dispatch time</span>
          </div>
          <div class="delivery-card green">
              <div class="d-icon">🚚</div>
              <p>Free Shipping</p>
              <span>To your location</span>
          </div>
          </div>

          <div class="benefits">
          <div>🛡️ Warranty Certificate Included</div>
          <div>✅ 100% Genuine Parts</div>
          </div>

          <div class="stock-warning">⚡ Limited stock at JC Road</div>

      </div>

      <!-- ══════════════════════════════════════════
          FULL KIT UI — 1 variable (isFullKit)
      ══════════════════════════════════════════ -->
      <div *ngIf="isFullKit" class="kit-card full">

          <!-- <div class="kit-header">
          <h2>Clutch Kit – Complete Set</h2>
          <p>All parts included. No need to buy anything else.</p>
          </div>
          <p class="section-title">WHAT YOU GET</p>
          <div class="items-row">
              <div class="item" *ngFor="let item of clutchList">
                  <div class="icon bg-yellow">⚙️</div>
                  <span>{{ item?.partName }}</span>
              </div>
          </div>
          <div class="included-bar center">✅ All included in this kit</div>
          <div class="kit-price">
            <div class="price-with-tag">
              <h3>₹{{ (selectedItem?.sellingPrice || 0) +    (clutchList[1]?.sellingPrice || 0) +    (clutchList[2]?.sellingPrice || 0) }}</h3>
              <span class="type-tag"> {{ selectedItem?.partType }}  </span>
            </div>
            <span>Final price • Full kit</span>
             <div class="kit-meta">
              <span>🏭 Brand: {{ selectedItem?.brand || '-' }}</span>
              <span>🔢 Part Number: {{ selectedItem?.partNumber || selectedItem?.partNo || '-' }}</span>
            </div>
          </div> -->
          <p class="section-title top-gap">DELIVERY TIMELINE</p>
          <div class="delivery-row">
          <div class="delivery-card blue">
              <div class="d-icon">⏱️</div>
              <p>Ready in 15 mins</p>
              <span>Dispatch time</span>
          </div>
          <div class="delivery-card green">
              <div class="d-icon">🚚</div>
              <p>Free Shipping</p>
              <span>To your location</span>
          </div>
          </div>

          <div class="benefits">
          <div>🛡️ Warranty Certificate Included</div>
          <div>✅ 100% Genuine Parts</div>
          </div>

          <div class="stock-warning">⚡ Limited stock at JC Road</div>

      </div>
      </div>

    <!-- ===== PRODUCT SPECIFICATIONS — full width, outside grid ===== -->
    <div class="specs-section">
      <h2 class="specs-heading">Product Specifications</h2>

      <div class="specs-grid">
        <!-- Left Card -->
        <!-- <div class="specs-card">
          <div class="spec-row">
            <div class="spec-left">
              <img _ngcontent-kdr-c321="" src="../../../../assets/images/productdetailsimage/brand.png" class="spec-icon">
              <span class="spec-label">Brand</span>
            </div>
            <span class="spec-value"> {{ selectedItem?.brand || '-' }}</span>
          </div>
          <div class="spec-divider"></div>

          <div class="spec-row">
            <div class="spec-left">
              <img _ngcontent-kdr-c321="" src="../../../../assets/images/productdetailsimage/parttype.png" class="spec-icon">
              <span class="spec-label">Part Type</span>
            </div>
            <span class="spec-value">{{ selectedItem?.partType || '-' }}</span>
          </div>
          <div class="spec-divider"></div>

          <div class="spec-row">
            <div class="spec-left">
              <img _ngcontent-kdr-c321="" src="../../../../assets/images/productdetailsimage/partno.png" class="spec-icon">
              <span class="spec-label">Part Number</span>
            </div>
            <span class="spec-value"> {{ selectedItem?.partNumber || '-' }}</span>
          </div>
        </div> -->

        <!-- Right Card -->
        <div class="specs-card">
          <div class="spec-row">
            <div class="spec-left">
              <img _ngcontent-kdr-c321="" src="../../../../assets/images/productdetailsimage/cat.png" class="spec-icon">
              <span class="spec-label">Category</span>
            </div>
            <span class="spec-value"> {{ selectedItem?.category || '-' }}</span>
          </div>
          <div class="spec-divider"></div>

          <div class="spec-row">
            <div class="spec-left">
              <img _ngcontent-kdr-c321="" src="../../../../assets/images/productdetailsimage/subcat.png" class="spec-icon">
              <span class="spec-label">Subcategory</span>
            </div>
            <span class="spec-value">Clutch Release Bearing</span>
          </div>
          <div class="spec-divider"></div>

          <div class="spec-row">
            <div class="spec-left">
              <img _ngcontent-kdr-c321="" src="../../../../assets/images/productdetailsimage/warranty.png" class="spec-icon">
              <span class="spec-label">Warranty</span>
            </div>
            <span class="spec-value">12 Months</span>
          </div>
        </div>
      </div>
    </div>
    <div class="features-container">
          <h2 class="title">Why You Should Order From Autoverse</h2>


          <div class="features-row">
          <div class="feature-box">
          <img src="../../../../assets/images/productdetailsimage/genune.png" class="icon" />
          <h3>Genuine Products</h3>
          <p>100% authentic parts from authorized manufacturers with full warranty coverage</p>
          </div>


          <div class="feature-box">
          <img src="../../../../assets/images/productdetailsimage/fast.png" class="icon" />
          <h3>Fast Delivery</h3>
          <p>Express shipping options available with real-time tracking for your peace of mind</p>
          </div>


          <div class="feature-box">
          <img src="../../../../assets/images/productdetailsimage/expert.png" class="icon" />
          <h3>Expert Support</h3>
          <p>Professional assistance from certified technicians available for all queries</p>
          </div>
          </div>


          <div class="mini-features-row">
          <div class="mini-feature">
          <img src="../../../../assets/images/productdetailsimage/fastD.png" class="mini-icon" />
          <h4>Fast Delivery</h4>
          <span>Available</span>
          </div>


          <div class="mini-feature">
          <img src="../../../../assets/images/productdetailsimage/return.png" class="mini-icon" />
          <h4>Easy Returns</h4>
          <span>Fast Refunds</span>
          </div>


          <div class="mini-feature">
          <img src="../../../../assets/images/productdetailsimage/best.png" class="mini-icon" />
          <h4>Best Price</h4>
          <span>Competitive</span>
          </div>


          <div class="mini-feature">
          <img src="../../../../assets/images/productdetailsimage/quality.png" class="mini-icon" />
          <h4>Quality</h4>
          <span>Guaranteed</span>
          </div>
          </div>
      </div>
      <div #compatabilityDiv >
          <div class="comapatable">
              <h3 class="faq-title">Check Compatibile Cars</h3>
              <mat-tab-group>
              <div *ngFor="let vehicle of compatability">
                  <mat-tab [label]="vehicle[0]">
                  <table  [ngClass]="isMobile ? 'toggle-comp-btnMobile' : 'toggle-comp-btn'">
                      <tr>
                      <th>Model</th>
                      <th>Fuel</th>
                      <th>Varient</th>
                      <th>Year</th>
                      </tr>
          
                      <tr *ngFor="let model of getVisibleModels(vehicle[1], vehicle[0]); let i = index">
                      <td>{{ model.model }}</td>
                      <td>{{ model.fuelType }}</td>
                      <td>{{ model.description }}</td>
                      <td>{{ model.yearFrom }}-{{ model.yearTo }}</td>
                      </tr>
                  </table>
                  <button (click)="toggleShowMore(vehicle[0])" 
                          [ngClass]="isMobile ? 'toggle-show-btnMobile' : 'toggle-show-btn'"
                          *ngIf="vehicle[1]?.length > 10" >
                      <div style="padding: 5px;">{{ showAllMap[vehicle[0]] ? 'Show Less' : 'Show More' }}</div>
                      <div style=" align-items: center; display: flex;">
                          <i class="material-icons" style="color: white; align-items: center;  display: flex;">
                              {{ showAllMap[vehicle[0]] ? 'expand_less' : 'expand_more' }}
                          </i>
                      </div>
                  </button>
                  </mat-tab>
              </div>
              
              </mat-tab-group>
          </div>
      </div>
  </div>
  <!-- END .page-wrapper -->


  <!-- Overlay -->
  <div class="popup-overlay" *ngIf="showPopup" (click)="closePopup()"></div>

  <!-- EMPTY STATE -->
  <div *ngIf="showEmptyState" class="empty-wrapper">

    <div class="empty-card">

      <!-- LEFT -->
      <div class="empty-left">
        <div class="placeholder-box">
          <img
            src="../../../../assets/images/cltch-kit-empty.jpeg"
            alt="Clutch Kit Empty"
            class="empty-image"
          />
        </div>
      </div>

      <!-- RIGHT -->
      <div class="empty-right">

        <h2>🔍 Clutch Kit Not Available Instantly</h2>

        <p class="sub-text">
          We couldn't find a ready-to-dispatch clutch kit for this vehicle.
        </p>

        <div class="info-box">
          Don’t worry — we’ll help you find the right parts quickly.
        </div>

        <button class="btn-secondary" (click)="createClutchRequest()">
          📩 Create Request for Clutch Kit
        </button>
      </div>

    </div>
  </div>
  <div class="popup" *ngIf="isPopupOpen">
    <div class="popup-content order-success-sec">
      <!-- <button mat-button (click)="closePopup()">Close</button> -->
      <img src="{{ successIcon }}" alt="Success Icon">
      <!-- <button class="close-popup" (click)="closePopup()">×</button> -->
      <mat-icon class="close-popup" (click)="closePopup()">close</mat-icon>
      <h3 *ngIf="addMoreItemsId">Request Updated!</h3>
      <h3 *ngIf="!addMoreItemsId">Request Created!</h3>
      <!-- <p class="order-label"><span class="order-id">Request ID  {{response.data.requestId}}</span></p> -->
      <p class="order-label">
        <span class="order-id">
          Request ID 
          {{ updatePopupData?.requestId || response?.data?.requestId }}
        </span>
      </p>
      <p class="date">
        <span>
          {{ updatePopupData?.requestCreatedAt || response?.data?.requestCreatedAt | date:'dd MMM yyyy, hh:mm a':'GMT+1060' }}
        </span>
      </p>
      <p class="date"  *ngIf="updatePopupData"><span>{{ response.data.requestCreatedAt | date:'dd MMM yyyy, hh:mm a':'GMT+1060' }}</span></p>
      <p class="thank-you">Let us deliver an awesome experience!</p>
      <!-- <button class="goto-order" (click)="closePopup()">Track My Request </button> -->
      <button class="goto-order" (click)="goToRequestDetails()">
        Track My Request
      </button>
    </div>
  </div>
</div>